module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/furniture_quantities/size-2-bde66c1643cee8b44a08ad928d7de08f.svg";